/**
 * Deep link into the accounts portal's change-plan page (TAJ-843). Used only by the
 * tiered-subscriptions flow — legacy membership and the Settings account link keep
 * linking to the portal root.
 */
export function buildChangePlanUrl(
  wahooMyAccountUrl: string,
  fitnessAppId: string | number,
  token: string
): string {
  return `${wahooMyAccountUrl}/subscriptions/change?faid=${fitnessAppId}&auth_token=${token}`;
}
